export enum PcsEventStatusEnum {
    Incomplete = "INCOMPLETE",
    Submitted = "SUBMIT",
    ApplicationApproved = "AA",
    NotApproved = "NA",
    RequiresFurtherDetails = "RFD"
}